import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getBookById } from "../../services/api";
import { useLanguage } from "../../contexts/LanguageContext";

const translations = {
  kz: {
    loading: "Жүктелуде...",
    notFound: "Кітап табылмады",
    error: "Қате орын алды",
    author: "Автор:",
    genre: "Жанр:",
    year: "Жылы:",
    quantity: "Таралым:",
    pieces: "дана",
    isbn: "ISBN:",
    annotation: "Аннотация:",
  },
  ru: {
    loading: "Загрузка...",
    notFound: "Книга не найдена",
    error: "Произошла ошибка",
    author: "Автор:",
    genre: "Жанр:",
    year: "Год:",
    quantity: "Тираж:",
    pieces: "шт.",
    isbn: "ISBN:",
    annotation: "Аннотация:",
  },
  en: {
    loading: "Loading...",
    notFound: "Book not found",
    error: "An error occurred",
    author: "Author:",
    genre: "Genre:",
    year: "Year:",
    quantity: "Print run:",
    pieces: "pcs",
    isbn: "ISBN:",
    annotation: "Annotation:",
  },
};

function BookDetail() {
  const { id } = useParams();
  const [book, setBook] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage] || translations.kz;

  useEffect(() => {
    const loadBook = async () => {
      try {
        const res = await getBookById(id);
        if (res.book) {
          setBook(res.book);
        } else {
          setError(t.notFound);
        }
      } catch {
        setError(t.error);
      } finally {
        setLoading(false);
      }
    };

    loadBook();
  }, [id, t]);

  if (loading) return <div className="loading">{t.loading}</div>;
  if (error || !book) return <div className="not-found">{error}</div>;

  return (
    <div className="book-detail-container">
      <div className="book-detail">
        <img
          className="book-image-detail"
          src={`${process.env.REACT_APP_API_URL}${book.img_url}`}
          alt={book.title}
        />
        <div className="book-information">
          <h1 className="book-title-detail">{book.title}</h1>
          <p>
            <strong>{t.author}</strong> {book.author}
          </p>
          <p>
            <strong>{t.genre}</strong> {book.Genr}
          </p>
          <p>
            <strong>{t.year}</strong> {book.year}
          </p>
          <p>
            <strong>{t.quantity}</strong> {book.quantity} {t.pieces}
          </p>
          {book.isbn &&
            <p>
              <strong>{t.isbn}</strong> {book.isbn}
            </p>
          }
          {book.annotation &&
            <p>
              <strong>{t.annotation}</strong> {book.annotation}
            </p>
          }
          <div className="social-icons-detail">
            <a href="https://www.facebook.com/nlrk.kz/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
            <a href="https://www.instagram.com/ulttyq_kitapkhana/?hl=ru%2F" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
            <a href="https://x.com/home" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
            <a href="https://vk.com/kitapkhana1931" target="_blank" rel="noopener noreferrer"><i className="fab fa-vk"></i></a>
            <a href="https://ok.ru" target="_blank" rel="noopener noreferrer"><i className="fab fa-odnoklassniki"></i></a>
            <a href="https://workspaceupdates.googleblog.com/2023/04/new-community-features-for-google-chat-and-an-update-currents%20.html" target="_blank" rel="noopener noreferrer"><i className="fab fa-google-plus-g"></i></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookDetail;
